export default "__VITE_ASSET__BGfJTTiZ__"